import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';

// Components
import Navbar from './components/Navbar';

// Pages
import HomePage from './pages/HomePage';
import CheckInPage from './pages/CheckInPage';
import AdminPage from './pages/AdminPage';
import SuccessPage from './pages/SuccessPage';
import RegisterPage from './pages/RegisterPage';
import RegisterSuccessPage from './pages/RegisterSuccessPage';
import OwnerLogin from './pages/OwnerLogin';
import OwnerDashboard from './pages/OwnerDashboard';
import ParkingLotPage from './pages/ParkingLotPage';
import SimpleParkingForm from './components/SimpleParkingForm';
import QRCodeGenerator from './components/QRCodeGenerator';
import QRCodeGeneratorPage from './pages/QRCodeGenerator';

function AppContent() {
  const location = useLocation();
  const isAdminPage = location.pathname.startsWith('/admin');
  const isOwnerPage = location.pathname.startsWith('/owner');
  const hideNavbar = isAdminPage || isOwnerPage;

  return (
    <div className="App">
      {!hideNavbar && <Navbar />}
      <Routes>
        <Route path="/" element={<SimpleParkingForm />} />
        <Route path="/checkin" element={<CheckInPage />} />
        <Route path="/checkin/:spotId" element={<CheckInPage />} />
        <Route path="/checkin/success" element={<SuccessPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/register/success" element={<RegisterSuccessPage />} />
        <Route path="/login" element={<OwnerLogin />} />
        <Route path="/owner/dashboard/:docId" element={<OwnerDashboard />} />
        <Route path="/park/:token" element={<ParkingLotPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/admin/qr-generator" element={<QRCodeGenerator />} />
        <Route path="/qr-generator" element={<QRCodeGeneratorPage />} />
      </Routes>
      <footer
        style={{
          textAlign: 'center',
          padding: '24px 16px',
          fontSize: '14px',
          color: '#6b7280',
        }}
      >
        Application created by{' '}
        <a
          href="https://primarydm.com"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: '#1e3a5f', fontWeight: 600, textDecoration: 'none' }}
        >
          Primary Digital Marketing
        </a>
      </footer>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
